import {
  DataGrid as MuiDataGrid,
  type DataGridProps,
  type GridValidRowModel,
} from '@mui/x-data-grid';
import { blue, slate } from '@/lib/colours';

export { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-pro';

export function DataGrid<T extends GridValidRowModel>(props: DataGridProps<T>) {
  return (
    <MuiDataGrid
      getRowClassName={(params) =>
        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
      }
      paginationMode="server"
      {...props}
      sx={{
        '&.MuiDataGrid-root': {
          borderWidth: '0px',
          minHeight: '200px',

          '.MuiDataGrid-overlayWrapper': {
            minHeight: '200px',
          },
        },
        '.MuiDataGrid-topContainer::after': {
          backgroundColor: 'unset',
        },
        '.MuiDataGrid-columnHeaderTitleContainerContent': {
          // Typography variant=titlesmall
          fontSize: '14px',
          fontWeight: '500',
          letterSpacing: '0.1px',
          color: `${slate[600]}`,
        },
        '.MuiDataGrid-row.even .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: slate[50],
        },
        '.MuiDataGrid-row.odd .MuiDataGrid-cell--pinnedRight': {
          backgroundColor: 'white',
        },
        '.MuiDataGrid-cell': {
          borderWidth: '0px',
          // Typography variant=bodysmall
          fontSize: '14px',
          fontWeight: '400',
          letterSpacing: '0.25px',
        },
        '.MuiDataGrid-footerContainer': {
          borderWidth: '0px',
        },
        '.even': {
          backgroundColor: slate[50],
        },
        '.odd': {},
        '.MuiTablePagination-root': {
          color: slate[500],

          '.MuiTablePagination-select': {
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: blue[600],
            borderRadius: '999px',
            padding: '8px',
            paddingRight: '32px !important',
            color: blue[600],
            transition: 'none',
          },
          '.MuiTablePagination-input svg': {
            color: blue[600],
            right: '8px',
          },
          '.MuiTablePagination-actions .MuiButtonBase-root:not(.Mui-disabled)':
            {
              color: blue[600],
              backgroundColor: blue[50],
              borderRadius: '999px',
              width: '32px',
              height: '32px',
              svg: {
                margin: '0px 6px',
              },
            },
        },
        ...props.sx,
      }}
    />
  );
}
